import { MaybePromise, isFunction } from '@direct-frontend/stdlib';
import { ValidationComparisonValue } from '../../types';

/**
 * Хелпер для корректной обработки валидаций сравнения
 * По возможности мы не должны делать валидатор асинхронным, поэтому:
 * 1. В случае получения синхронной функции получения значения сравнения или статичного значения валидируем синхронно
 * 2. В случае с переданным асинхронным коллбеком для получения значения сравнения уже обрабатываем промис
 * */
export const handleComparisonValidation = <ComparisonValue, FieldContext>({
    comparisonValue,
    validationCallback,
    context,
}: {
    comparisonValue: ValidationComparisonValue<ComparisonValue, FieldContext>;
    validationCallback: (comparisonValue: ComparisonValue) => void;
    context: FieldContext;
}): MaybePromise<void> => {
    const handledComparisonValue = isFunction(comparisonValue) ? comparisonValue(context) : comparisonValue;

    if (handledComparisonValue instanceof Promise) {
        return handledComparisonValue.then(value => validationCallback(value));
    }

    validationCallback(handledComparisonValue);
};
